const KEY = 'borrah-workspace-deletion-auth';
export function saveDeletionAuthProof(proof: string | undefined) {
  try {
    if (proof) sessionStorage.setItem(KEY, proof);
    else sessionStorage.removeItem(KEY);
  } catch {
    /* Deletion fails closed if storage is unavailable. */
  }
}
export function getDeletionAuthProof() {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}
